import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { Breadcrumbs } from '@mui/material';
import withNotify from '../../common/withNotify';
import { notifySet } from '../../Services/Actions/CommonActions';
import StartUpForm from './StartUpForm';
import { updateStartUp, viewStartUp } from '../../Services/Utils/StartupApis';

function EditStartUp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [processing, setProcessing] = useState(false);
  useEffect(() => {
    viewStartUp({ id: params.id }).then((res) => {
      dispatch(change('startUpForm', 'name', res.view.name));
      dispatch(change('startUpForm', 'registeredName', res.view.registeredName));
      dispatch(change('startUpForm', 'email', res.view.email));
      dispatch(change('startUpForm', 'pocEmail', res.view.pocEmail));
      dispatch(change('startUpForm', 'pocName', res.view.pocName));
      // dispatch(change('startUpForm', 'pocMobile', res.view.pocMobile));
      dispatch(change('startUpForm', 'mobile', res.view.mobile));
      dispatch(change('startUpForm', 'founderName', res.view.founderName));
      if (res.view.planView) {
        const planView = {
          id: res.view.planView.id,
          text: res.view.planView.name,
          label: res.view.planView.name,
          value: res.view.planView.name
        };
        dispatch(change('startUpForm', 'plan', planView));
      }
    });
  }, []);
  const onButtonClick = (formData) => {
    setProcessing(true);
    const data = {
      id: params.id,
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      hasLoggedIn: true,
      roleView: {
        id: 2,
      },
      registeredName: formData.registeredName,
      founderName: formData.founderName,
      pocName: formData.pocName,
      pocEmail: formData.pocEmail,
      // pocMobile: formData.pocMobile,
      planView: {
        id: formData.plan.id
      }
    };
    updateStartUp(data).then((res) => {
      setProcessing(false);
      if (res.hasError === false) {
        navigate('/startups');
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div>
      <div className="container-fluid ">
        <div className="breadcrumb-menu-con">
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
          >
            <Link to="/startups">Startup</Link>
            <Link to="#">Edit Startup</Link>
          </Breadcrumbs>
        </div>
        <div>
          <div className="row">
            <div className="col-sm-12">
              <div>
                <StartUpForm
                  onButtonClick={onButtonClick}
                  startupText="Edit Startup"
                  processing={processing}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withNotify(EditStartUp);
